import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import { AppLayout } from './components/AppLayout.tsx';
import { BrandManagement } from './pages/BrandManagement.tsx';
import Settings from './pages/Settings.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { ToastProvider } from './contexts/ToastContext.tsx';
import { ApiProvider } from './contexts/ApiContext.tsx';
import '@shopify/polaris/build/esm/styles.css';
import './index.css';

// Get URL parameters for Shopify App Bridge
const urlParams = new URLSearchParams(window.location.search);
const shop = urlParams.get('shop');
const host = urlParams.get('host');

// App Bridge configuration
const config = {
  apiKey: process.env.REACT_APP_SHOPIFY_API_KEY || '20c484608a205ba4778975469ae03cda',
  host: host || process.env.REACT_APP_HOST || 'deliverydatemanager.getshopsync.com',
  forceRedirect: true,
};

function App() {
  // Check if required parameters are present
  if (!shop) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>⚠️ App Initialization Error</h2>
        <p>Missing required URL parameter: shop</p>
        <p>Please access this app through your Shopify admin panel.</p>
      </div>
    );
  }

  if (!host) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>⚠️ App Initialization Error</h2>
        <p>Missing required URL parameter: host</p>
        <p>Please access this app through your Shopify admin panel.</p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <AppBridgeProvider config={config}>
        <AppProvider i18n={{}}>
          <ToastProvider>
            <ApiProvider>
              <Router>
                <AppLayout>
                  <Routes>
                    <Route path="/" element={<BrandManagement />} />
                    <Route path="/brands" element={<BrandManagement />} />
                    <Route path="/settings" element={<Settings />} />
                  </Routes>
                </AppLayout>
              </Router>
            </ApiProvider>
          </ToastProvider>
        </AppProvider>
      </AppBridgeProvider>
    </ErrorBoundary>
  );
}

export default App;
